import React, { Component } from "react";
import { connect } from 'react-redux';
import { verifyAdminStatus } from '../../-global-state/actions/user-actions';
import './admin.css';

class Admin extends Component {
    constructor(){
        super();
        this.state = {
            stockExchange: '',
            bargainAmount: '',
            startNumber: '',
            endNumber: '',
            formInformation: {}
        }
    }

    componentDidMount = () => {
        this.adminStatus(localStorage.getItem("token"));
    }

    displayForm = () => {
        return (
            <form className="my-form border border-dark p-5" onSubmit={this.handleFormSubmit}>
                <div className="form-group">
                    <input type="text" className="form-control bg-dark text-white mb-2" id="stockExchange" placeholder="stock exchange" maxLength="25" required={true} 
                        value={this.state.stockExchange} 
                        onChange={e => this.setState({ stockExchange: e.target.value })}
                    />
                    <input type="text" className="form-control bg-dark text-white mb-2" id="bargainAmount" placeholder="bargain amount" maxLength="25" required={true}
                        value={this.state.bargainAmount} 
                        onChange={e => this.setState({ bargainAmount: e.target.value })}
                    />
                    <input type="text" className="form-control bg-dark text-white mb-2" id="startNumber" placeholder="start number" maxLength="25" required={true}
                        value={this.state.startNumber} 
                        onChange={e => this.setState({ startNumber: e.target.value })}
                    />
                    <input type="text" className="form-control bg-dark text-white mb-2" id="endNumber" placeholder="end number" maxLength="25" required={true}
                        value={this.state.endNumber} 
                        onChange={e => this.setState({ endNumber: e.target.value })}
                    />
                </div>
                <button type="submit" className="btn btn-success btn-lg submit-button">V</button>
            </form>
        )
    }

    render() { 
        if (this.props.isAdmin === true) {
            return (
            <div id="admin">
                <div className="container d-flex align-items-center justify-content-center admin-container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h1 className="display-1 text-white py-2">Admin</h1>
                        </div>
                        <div className="col-12 text-center pb-3">
                            <button type="submit" className="btn btn-success btn-lg w-50" onClick={() => this.handleUpdateBargainsList()}>Update Bargain List</button>
                        </div>
                        <div className="col-12 text-center">
                            <h1 className="display-1 text-white py-2">
                                {this.displayForm()}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            );
        } else {
            return (
                <div className="container d-flex align-items-center justify-content-center not-admin-container">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="text-white">Not an Admin.</h1>
                        </div>
                    </div>
                </div>
            )
        }
    }

    handleFormSubmit = e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        this.setState({ formInformation: {
            stockExchange: this.state.stockExchange,
            bargainAmount: this.state.bargainAmount,
            startNumber: this.state.startNumber,
            endNumber: this.state.endNumber
        }}, () => {
            fetch(process.env.REACT_APP_FORM_SUBMIT, {
                method: 'post',
                mode: 'cors',
                body: JSON.stringify(this.state.formInformation),
                headers: {
                    "Content-type" : "application/json",
                    'Authorization': `Bearer ${token}`
                }
            }).then(response => response.json()).then(json => {
                alert(json.message);
                this.setState({
                    stockExchange: '',
                    bargainAmount: '',
                    startNumber: '',
                    endNumber: '',
                    formInformation: {}
                })
            })
        })
    }

    handleUpdateBargainsList = () => {
        const token = localStorage.getItem('token');
        fetch(process.env.REACT_APP_UPDATE_BARGAINS, { method: 'GET', headers: { 'Authorization': `Bearer ${token}` }}).then(response => response.json().then(json => {
            alert(json.message);
        }))
    }

    adminStatus = token => {
        this.props.verifyAdminStatus(token);
    }

}
 
const mapStateToProps = state => {
    return {
        isAdmin: state.adminState.isAdmin,
    }
}

export default connect(mapStateToProps, { verifyAdminStatus })(Admin);